import Default from './Sections/Default';
import Finish from './Sections/Finish';
import React from 'react';
import Section from './Sections/Section';
import useStyles from './style';
import { getUserRole } from 'src/utils/useUser';
import { useAppSelector } from 'src/hooks/redux-hooks';
import { useStates } from 'src/utils/useState';

const WelcomeScreen: React.FunctionComponent = () => {

  const classes = useStyles();
  const userData = useAppSelector((state: any) => state.user);

  const setup = [
    {
      key: 'timeline',
      state: null,
      roles: [
        "parent",
        "teacher",
        "director",
      ],
      title: {
        director: "Nástěnka",
        teacher: "Nástěnka",
        parent: "Nástěnka",
      },
      header: {
        director: "Sdílejte radost s rodiči",
        teacher: "Sdílejte radost s rodiči",
        parent: "Vše o vašem děťátku na jednom místě",
      },
      text: {
        director: "Vytvořte si s rodiči pevné pouto a společně oslavujte každý úspěch. Nástěnka vám umožní snadno sdílet úsměvy, úspěchy a vzácné okamžiky z vašeho dne s dětmi i důležité informace k organizaci.",
        teacher: "Vytvořte si s rodiči pevné pouto a společně oslavujte každý úspěch. Nástěnka vám umožní snadno sdílet úsměvy, úspěchy a vzácné okamžiky z vašeho dne s dětmi i důležité informace k organizaci.",
        parent: "Chcete mít přehled o tom, co vaše dítě právě zažívá ve školce? Naše nástěnka vám přinese fotky, videa a zprávy přímo z jeho třídy. Buďte vždy v obraze a nenechte si ujít žádný důležitý okamžik.",
      },
    },
    {
      key: 'finance',
      state: null,
      roles: [
        "parent",
      ],
      title: {
        director: "",
        teacher: "",
        parent: "Finance",
      },
      header: {
        director: "",
        teacher: "",
        parent: "Transparentní finance",
      },
      text: {
        director: "",
        teacher: "",
        parent: "Mějte vždy přehled o svých platbách a jejich detailním rozpisu. SLedujte své platby za školku přímo v aplikaci.",
      },
    },
    {
      key: 'classbook',
      state: null,
      roles: [
        "teacher",
        "director",
      ],
      title: {
        director: "Třídnice",
        teacher: "Třídnice",
        parent: "",
      },
      header: {
        director: "Kompletní elektronická dokumentace",
        teacher: "Kompletní elektronická dokumentace",
        parent: "",
      },
      text: {
        director: "Od bezpečnostních poučení až po individuální pokroky dětí – vše najdete přehledně v třídnici",
        teacher: "Od bezpečnostních poučení až po individuální pokroky dětí – vše najdete přehledně v třídnici",
        parent: "",
      },
    },
    {
      key: 'premium_parent',
      state: null,
      roles: [
        "parent",
      ],
      title: {
        director: "",
        teacher: "",
        parent: "Premium rodič",
      },
      header: {
        director: "",
        teacher: "",
        parent: "Zachovejte si vzácné okamžiky",
      },
      text: {
        director: "",
        teacher: "",
        parent: "Vaše dítě ve školce prožívá kouzelná dobrodružství. S předplatným služby Premium rodič si zachováte všechny fotografie a s nimi krásné vzpomínky na období školky.",
      },
    },
    {
      key: 'attendance',
      state: null,
      roles: [
        "teacher",
        "director",
      ],
      title: {
        director: "Docházka",
        teacher: "Docházka",
        parent: "",
      },
      header: {
        director: "Vždy aktuální informace",
        teacher: "Vždy aktuální informace",
        parent: "",
      },
      text: {
        director: "Všichni pedagogové mají přístup k nejnovějším údajům o docházce dětí. Automatické výpočty docházky vám pomůžou s výpočtem poplatků bez chyb.",
        teacher: "Všichni pedagogové mají přístup k nejnovějším údajům o docházce dětí. Automatické výpočty docházky vám pomůžou s výpočtem poplatků bez chyb.",
        parent: "",
      },
    },
    {
      key: 'excuse_notes',
      state: null,
      roles: [
        "parent",
      ],
      title: {
        director: "",
        teacher: "",
        parent: "Omluvenky",
      },
      header: {
        director: "",
        teacher: "",
        parent: "Vždy informováni o absenci",
      },
      text: {
        director: "",
        teacher: "",
        parent: "Budete okamžitě vědět, zda byla vaše omluvenky přijata. Můžete snadno sledovat všechny absence vašeho dítěte.",
      },
    },
    {
      key: 'calendar',
      state: null,
      roles: [
        "parent",
        "teacher",
        "director",
      ],
      title: {
        director: "Kalendář",
        teacher: "Kalendář",
        parent: "Kalendář",
      },
      header: {
        director: "Jednoduchá tvorba událostí",
        teacher: "Jednoduchá tvorba událostí",
        parent: "Nikdy nic nepropásnete",
      },
      text: {
        director: "Pořádáte představení nebo třídní schůzky a potřebujete rodiče o této události informovat? Nebo chcete vytvořit událost pro ostatní učitele? Vytvořte ji v kalendáři. Rodiče či učitelé pak tuto událost najdou ve svém kalendáři ve webové aplikaci a rovněž se jim objeví v příspěvku na nástěnce.",
        teacher: "Pořádáte představení nebo třídní schůzky a potřebujete rodiče o této události informovat? Nebo chcete vytvořit událost pro ostatní učitele? Vytvořte ji v kalendáři. Rodiče či učitelé pak tuto událost najdou ve svém kalendáři ve webové aplikaci a rovněž se jim objeví v příspěvku na nástěnce.",
        parent: "Buďte vždy v obraze o všech důležitých událostech ve školce. Automaticky vás budeme informovat o každém představení, schůzce a dalších akcí vašeho dítěte.",
      },
    },
    {
      key: 'communication',
      state: null,
      roles: [
        "parent",
        "teacher",
        "director",
      ],
      title: {
        director: "Twigchat",
        teacher: "Twigchat",
        parent: "Twigchat",
      },
      header: {
        director: "Vaše spojení s rodiči",
        teacher: "Vaše spojení s rodiči",
        parent: "Zůstaňte v kontaktu",
      },
      text: {
        director: "Chcete komunikovat s rodiči a rodiče s Vámi? TwigChat vám umožní snadnou a bezpečnou komunikace s rodiči přímo v aplikaci. Všechny konverzace s rodiči budete mít přehledně uspořádané a rychle dostupné.",
        teacher: "Chcete komunikovat s rodiči a rodiče s Vámi? TwigChat vám umožní snadnou a bezpečnou komunikace s rodiči přímo v aplikaci. Všechny konverzace s rodiči budete mít přehledně uspořádané a rychle dostupné.",
        parent: "Snadná komunikace s učiteli přímo v aplikaci. Mějte všechny zprávy od učitelů přehledně uspořádané.",
      },
    },
    {
      key: 'press_report',
      state: null,
      roles: [
        "teacher",
        "director",
      ],
      title: {
        director: "Tiskové sestavy",
        teacher: "Tiskové sestavy",
        parent: "",
      },
      header: {
        director: "Sestavy dle vašich potřeb",
        teacher: "Sestavy dle vašich potřeb",
        parent: "",
      },
      text: {
        director: "Přes tiskové sestavy můžete vytvořit export obsahující informace o dětech, který si můžete snadno navrhnout podle svých individuálních potřeb.",
        teacher: "Přes tiskové sestavy můžete vytvořit export obsahující informace o dětech, který si můžete snadno navrhnout podle svých individuálních potřeb.",
        parent: "",
      },
    },
  ];
  
  const sections = setup.filter((item: any) => item.roles.includes(getUserRole(userData.userObject.roleType))).map((item: any) => {
    return { ...item};
  });

  const [state, setState] = useStates({
    section: 'default',
    sections: sections,
  });

  const userRole = getUserRole(userData.userObject.roleType);

  const getNextSection = () => {
    const currentIndex = sections.findIndex((item: any) => item.key === state.section);
    const newIndex = currentIndex + 1;
    const isNextSection = sections.length > newIndex;
    const getNextSection = state.section === "default" ? sections[0].key : isNextSection ? sections[newIndex].key : "finish";
    return getNextSection;
  };

  const handleNext = () => {
    const section = getNextSection();
    setState("section", section);
  };

  const getPreviousSection = () => {
    const currentIndex = sections.findIndex((item: any) => item.key === state.section);
    const newIndex = currentIndex - 1;
    const isPrevSection = newIndex >= 0;
    const getPreviousSection = state.section === "default" ? sections[0].key : isPrevSection ? sections[newIndex].key : "default";
    return getPreviousSection;
  };

  const handleBack = () => {
    const section = getPreviousSection();
    setState("section", section);
  };

  const getTitle = () => {
    const sectionData = sections.find((item: any) => item.key === state.section);
    return sectionData.title;
  };

  const getHeader = () => {
    const sectionData = sections.find((item: any) => item.key === state.section);
    return sectionData.header;
  };

  const getText = () => {
    const sectionData = sections.find((item: any) => item.key === state.section);
    return sectionData.text;
  };

  return (
    <div className={classes.welcomeScreen}>
      <div className={classes.content}>
        <div className={classes.body}>
          {
            state.section === "default" ? (
              <Default handleNext={handleNext}/>
            ) : state.section === "finish" ? (
              <Finish/>
            ) : (
              <Section section={state.section} title={getTitle()} header={getHeader()} text={getText()} handleBack={handleBack} handleNext={handleNext}/>
            )
          }
          <div className={classes.preloadImages}>
            <img src={`/resources/images/welcomescreen/${userRole}_default.png`}/>
            {
              sections.map((item: any, key: any) => (
                <img src={`/resources/images/welcomescreen/${userRole}_${item.key}.png`} key={`k_${key}`}/>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;